export default class PrintPage {
    constructor($trigger) {
        this.$trigger = $trigger;
        this.$trigger.addEventListener('click', (event) => this.print(event));
    }

    print(event) {
        event.preventDefault();

        if (typeof window.print === 'function') {
            window.print();
        }
    }
}
